import BrandLogo from "@/components/BrandLogo";

export default function IntakeHeader({ currentStep = 1, totalSteps = 6 }) {
    const pct = Math.max(0, Math.min(100, (currentStep / totalSteps) * 100));
    return (
        <div className="w-full" data-testid="intake-header-wrap">
            <div className="px-6 md:px-10 py-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <BrandLogo size="sm" testId="brand-logo-header" />
                    <span className="text-sm md:text-base text-white/85 tracking-wide" data-testid="intake-title">
                        Secure Client Intake
                    </span>
                </div>
                <div className="text-xs sm:text-sm gold-text font-medium tracking-wide" data-testid="step-counter">
                    Step {currentStep} of {totalSteps}
                </div>
            </div>
            <div className="relative h-[3px] w-full bg-[#0a1628]/60">
                <div
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#AA7C11] via-[#D4AF37] to-[#F3E5AB] transition-[width] duration-500 ease-out"
                    style={{ width: `${pct}%`, boxShadow: "0 0 14px rgba(212,175,55,0.7)" }}
                />
            </div>
        </div>
    );
}
